import React from 'react';
import useLocale from '@/hooks/useLocale';
import * as Styles from './ActivitiesChart.styles';
import withErrorBoundary from '@/utils/errorBoundary';
import { Chart } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from 'chart.js';
import {
  ChartPagination,
  ChartPaginationContext,
  useChartPagination,
} from './ChartPagination';
import emptyIconPath from '../../media/empty-state-graphic-bar.svg';
import { useActivitiesChart } from './useActivitiesChart';

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
);

const ActivitiesChart = ({
  data = [],
  pageSize,
}) => {
  const { gatorProtect: gatorProtectLocale } = useLocale();
  const content = gatorProtectLocale && gatorProtectLocale.activitiesChart;

  const safeData = data;
  const isEmpty = safeData.length === 0;

  const pagination = useChartPagination(safeData, pageSize);
  const { pageItems } = pagination;
  const { chartData, chartOptions } = useActivitiesChart(pageItems, content || {});

  if (isEmpty) {
    return (
      <Styles.EmptyStateContainer data-testid="empty-state">
        <Styles.EmptyImage src={emptyIconPath} alt={(content && content.emptyImageAlt) || ''} />
        <Styles.EmptyTitle>{(content && content.emptyTitle) || ''}</Styles.EmptyTitle>
        <Styles.EmptyDescription>{(content && content.emptyDescription) || ''}</Styles.EmptyDescription>
      </Styles.EmptyStateContainer>
    );
  }

  return (
    <ChartPaginationContext.Provider value={pagination}>
      <Styles.ChartContainer>
        <Chart type="bar" data={chartData} options={chartOptions} />
      </Styles.ChartContainer>
      <ChartPagination.Bar />
    </ChartPaginationContext.Provider>
  );
};

export default withErrorBoundary(ActivitiesChart, 'ActivitiesChart');
